import React from 'react';

function NoToDos() {
  return (
    <p className='p-create-to-do'> No To-Do's found. Create one!</p>
  )
}

export { NoToDos }